import { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Outlet } from '@usas/ui-web/wrappers/ReactRouterDom';

import Group from './views/groups/Group';
import NTGroups from './views/nationalTeamGroups/NTGroups';
import SAAGroups from './views/scholasticAllAmerica/SAAGroups';

import UnexpectedError from '@usas/ui-web/components/UnexpectedError';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import ErrorBoundary from '@usas/ui-web/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@usas/ui-web/components/errors/ErrorBoundaryFallback';

const AppRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Routes>
        <Route path={navRoutes['HOME']?.path} element={<Fragment><Outlet /></Fragment>}>
          <Route path={navRoutes['GROUP_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['GROUP_ROOT']}
                editElement={<Group />} />
            }
          />
          <Route path={navRoutes['NT_GROUP_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['NT_GROUP_ROOT']}
                editElement={<NTGroups />} />
            }
          />
          <Route path={navRoutes['SAA_GROUP_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['SAA_GROUP_ROOT']}
                editElement={<SAAGroups />} />
            }
          />

          <Route path="500" element={<UnexpectedError />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;